import __request__ from "routing/request";
export function types(requestOptions) {
  return __request__("GET", "/system/inputs/types", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function all(requestOptions) {
  return __request__("GET", "/system/inputs/types/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function info(inputType, requestOptions) {
  return __request__("GET", `/system/inputs/types/${inputType}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
